import { ApiError } from '@/lib/api'

/**
 * German for the gateway's auth refusals.
 *
 * `internal/api/auth_handlers.go` answers in English ("email already in use",
 * "invalid email or password") and binding failures come back as go-playground
 * validator prose, which is not something to put in front of a person. Only
 * the cases that are actually reachable are translated; anything else keeps
 * the server's own message rather than being flattened into a shrug.
 */

export function registerErrorMessage(cause: unknown): string {
  const error = ApiError.from(cause)
  if (error.status === 409) {
    return 'Für diese E-Mail-Adresse gibt es schon ein Konto. Melde dich bitte an oder setze dein Passwort zurück.'
  }
  if (error.status === 400) {
    // The only binding rules on the register body are a valid address and a
    // password of at least 8 characters.
    return 'Bitte prüfe deine E-Mail-Adresse und wähle ein Passwort mit mindestens 8 Zeichen.'
  }
  if (error.status === 503) {
    return 'Die Registrierung ist gerade nicht erreichbar. Bitte versuche es später noch einmal.'
  }
  return error.message
}

export function loginErrorMessage(cause: unknown): string {
  const error = ApiError.from(cause)
  if (error.status === 401) return 'E-Mail-Adresse oder Passwort stimmt nicht.'
  if (error.status === 403) return 'Dieses Konto ist deaktiviert.'
  return error.message
}

export function resendErrorMessage(cause: unknown): string {
  const error = ApiError.from(cause)
  // Five per hour and per account (`resendVerificationRateLimit`). Say what
  // happened and when it is worth trying again, rather than "Fehler 429".
  if (error.code === 'resend_rate_limited' || error.status === 429) {
    return 'Du hast schon mehrere Bestätigungs-E-Mails angefordert. Bitte warte eine Stunde, bevor du es noch einmal versuchst.'
  }
  if (error.status === 401) return 'Deine Sitzung ist abgelaufen. Bitte melde dich noch einmal an.'
  return error.message
}

/** The reset and verification tokens both come out of an e-mail link and
 *  both answer 400 when they are old, used or invented. */
export function tokenErrorMessage(cause: unknown): string {
  const error = ApiError.from(cause)
  if (error.status === 400) {
    return 'Dieser Link ist ungültig oder abgelaufen. Fordere bitte einen neuen an.'
  }
  return error.message
}
